import dayjs from "dayjs"
import PropTypes from "prop-types"
import React from "react"
import { useHistory } from "react-router-dom"
import styled from "styled-components"

import { USER_AUTH_HEADER } from "../../../../../api"
import AppHeader from "../../../../_shared/components/AppHeader"
import EventCard from "../../../../_shared/components/EventCard"
import ScreenTitle from "../../../../_shared/components/Typography/ScreenTitle"
import UserBookings from "../../../../_shared/components/UserBookings"
import useRestList from "../../../../_shared/hooks/useRestList"

// ----------------------------------------------------------------------------

function Events(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [events] = useRestList("/events/summary-view", USER_AUTH_HEADER)
    const history = useHistory()

    events?.sort(sortFunction)

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function sortFunction(a, b) {
        const date1 = dayjs(a?.date)?.unix()
        const date2 = dayjs(b?.date)?.unix()
        return date1 - date2
    }

    function renderEvents() {
        return (
            <div className="event-grid">
                {events.map((event) => (
                    <EventCard
                        key={event.id}
                        {...event}
                        onClick={() => {
                            // toLoginWithSuccessRedirect(history, {
                            //     redirect: `/events/${event.id}`,
                            //     minAge: event.minimumAge,
                            //     maxAge: event.maximumAge,
                            // })
                            history.push(`/events/${event.id}`)
                        }}
                    />
                ))}
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <AppHeader />
            {<UserBookings />}
            <main>
                <ScreenTitle
                    className="screen-title"
                    text="Eventi disponibili"
                />
                {renderEvents()}
            </main>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

Events.propTypes = {
    className: PropTypes.string.isRequired,
}

Events.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledEvents = styled(Events)`
    & {
        main {
            margin-top: 50px;
            display: flex;
            flex-direction: column;
            align-items: "center";
            padding-bottom: 50px;
            .screen-title {
                margin-bottom: 50px;
            }
            .event-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                width: 100%;
                min-height: 500px;
                padding: 0px 20%;
                grid-gap: 85px;
            }
        }
        @media (max-width: 1500px) {
            main {
                .event-grid {
                    padding: 0 10%;
                    grid-gap: 50px;
                }
            }
        }
        @media (max-width: 1000px) {
            main {
                .event-grid {
                    padding: 0 2%;
                    grid-gap: 30px;
                }
            }
        }
        @media (max-width: 768px) {
            main {
                .event-grid {
                    padding: 0 10%;
                    grid-template-columns: 1fr;
                }
            }
        }
        @media (max-width: 576px) {
            main {
                max-width: 100vw;
                .event-grid {
                    padding: 0 3%;
                    grid-template-columns: 1fr;
                }
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledEvents
